<template>
  <v-form
    class="bg-light py-md-3 py-1 px-3 rounded mb-1"
    @submit.prevent="submit()"
  >
    <div class="row">
      <div class="col-2">
        ID: {{ survey_question.id }}
      </div>
      <div class="col-3">
        <div class="pb-0">
          <v-text-field
            v-model="survey_question.objective_id"
            variant="outlined"
            density="compact"
            bg-color="white"
            label="Trackable ID*"
            :error-messages="v$.survey_question.objective_id.$errors.map((e) => e.$message)"
            @blur="v$.survey_question.objective_id.$touch()"
          />
        </div>
      </div>
      <div class="col-3">
        <div class="pb-0">
          <v-text-field
            v-model="survey_question.question_number"
            variant="outlined"
            density="compact"
            bg-color="white"
            label="Question ID*"
            :error-messages="v$.survey_question.question_number.$errors.map((e) => e.$message)"
            @blur="v$.survey_question.question_number.$touch()"
          />
        </div>
      </div>
      <div class="col-2">
        {{ lookup.languages.find(obj => (obj.id == survey_question.language_id)).name }}
      </div>

      <div class="col-2">
        <button
          type="button"
          class="btn btn-default btn-sm"
          :disabled="isLoading"
          @click="save"
        >
          Save <span
            v-show="isLoading"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  </v-form>
  <v-snackbar
    v-model="isSnackbarOpen"
    :timeout="3000"
    location="top right"
  >
    <v-alert
      color="#dfe8e8"
      :title="title"
      :text="message"
    />
  </v-snackbar>
</template>

<script>
import axios from 'axios';
import { useVuelidate } from '@vuelidate/core';

import { lookup } from '../lookup/lookup';

import { appValidator } from '../../common/core/utils/validator';

export default {
  props: ['modelValue', 'index'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      survey_question: { ...this.modelValue },
      lookup,
      isLoading: false,
      isSnackbarOpen: false,
      message: '',
      title: '',
    };
  },

  validations() {
    return {
      survey_question: {
        objective_id: {
          required: appValidator.required,
        },
        question_number: {
          required: appValidator.required,
        },

      },
    };
  },

  methods: {

    validate() {
      let error = false;
      if (this.v$.$invalid) {
        this.v$.$touch();
        error = true;
      }

      return !error;
    },

    async save() {
      if (!this.validate()) {
        return;
      }

      this.isLoading = true;
      const response = await axios.put(
        `/api/elearning/survey-questions/${this.survey_question.id}`,
        this.survey_question,
      );
      this.isLoading = false;
      this.openSnackbar('Saved', 'Survey Question');

      // this.$emit('input', this.user);
    },
    openSnackbar(title, message) {
      this.isSnackbarOpen = true;
      this.title = title;
      this.message = message;
    },
  },
};
</script>
